module.exports = __webpack_public_path__ + "img/5.4d37d51b.png";